import AccessibilityNotificationComponent from './accessibility-notifications.component';
import * as accessibilityNotificationsActions from './accessibility-notifications.actions';
import { accessibilityNotificationReducer } from './accessibility-notifications.reducer';
import { accessibilityNotificationsEmitter } from './accessibility-notifications.emitter';

export {
  AccessibilityNotificationComponent,
  accessibilityNotificationsActions,
  accessibilityNotificationReducer,
  accessibilityNotificationsEmitter,
}



// WEBPACK FOOTER //
// src/common/accessibility-notifications/index.js